import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import MultiInputTag from "./MultiInputTag";
import MultiInputTagText from "./MultiInputTagText";

const NestedInput = ({ item, text, service }) => {
  const {
    label,
    name,
    type,
    multiple,
    multipleData,
    required,
    noDropdown,
    fullCol,
  } = item;

  const element = (item, index) => {
    return service ? (
      <MultiInputTagText
        label={label}
        length={index + 1}
        name={name}
        nameDefaultValue={item?.defaultValue?.title}
        defaultValue={item?.defaultValue?.text}
        type={type}
        required={required}
        textArea={true}
        fullCol={fullCol}
      />
    ) : text ? (
      <MultiInputTagText
        label={label}
        length={index + 1}
        name={name}
        nameDefaultValue={item?.defaultValue[0]}
        defaultValue={noDropdown ? "" : item?.defaultValue[1]}
        type={type}
        required={required}
      />
    ) : (
      <MultiInputTag
        label={label}
        length={index + 1}
        name={name}
        icon={item?.defaultValue?.length ? item.defaultValue[0] : ""}
        defaultValue={noDropdown ? item.defaultValue : item.defaultValue[1]}
        type={type}
        required={required}
        noDropdown={noDropdown}
      />
    );
  };

  const elementNew = () => {
    return text ? (
      <MultiInputTagText
        label={label}
        name={name}
        type={type}
        required={required}
      />
    ) : (
      <MultiInputTag
        label={label}
        name={name}
        type={type}
        required={required}
        noDropdown={noDropdown}
      />
    );
  };

  const [quantityCount, setCount] = useState(
    multipleData
      ? multipleData
      : [
          {
            label: label,
            type: "text",
            name: "",
            defaultValue: [],
          },
        ]
  );

  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: "text",
        name: "",
        defaultValue: [],
      },
    ]);
  };
  return (
    <div className={`flex flex-col w-full ${fullCol ? "col-span-2" : ""}`}>
      {noDropdown && (
        <label className="label">
          <span className="text-base font-semibold">{label}</span>
        </label>
      )}
      <div className="col-span-2 flex flex-col gap-4 w-full fitHeight ">
        <div className="col-span-2 w-full">
          {quantityCount
            ? quantityCount.map((item, index) => element(item, index))
            : elementNew()}
        </div>

        {multiple && (
          <div className="flex justify-end items-end">
            <button
              onClick={handleAddElement}
              type="button"
              className="btn btn-circle"
            >
              <BsPlusLg />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NestedInput;
